import React from 'react';
import { Section, InnerSection } from '../../../styles/section/section';
import {
  HeaderTextBlock,
  HeaderTextBlockTitle
} from '../../../styles/text-block/header-text-block';
import { useBreakpoint } from '../../../helpers/breakpoint-provider';
import { VideoCarousel } from '../../../styles/video-carousel';
import { useHomeContext } from '../context';
import { SendInViewEvent } from '../../../helpers/send-in-view-event';

/**
 * NOTE: We do not have a straightforward way to manage the videos or ordering from the CMS
 * for these "Homepage" Quick Answers videos.
 *
 * As a semi-temporary solution, we will sort the videos based on a predefined order array.
 * The definition array is the unique `video.youtube_id` value that is present in the CMS.
 */
const videoOrderDefinition = [
  'KmmJSuOxmRo', // What is Carvana?
  'jrE5cC6a85w', // How Do I Buy A Car with Carvana?
  'zmJWNuVvKIQ', // How Do I Sell My Car to Carvana?
  '61gWC__Z8Vg', // How Do I Finance My Car with Carvana?
  'g_9tddKNNNQ', // What is Loan Underwriting?
  '5PVfwpr4Kig', // How Do I Check My Carvana Documents?
  'tPKlznmwTIU', // Car Financing Tips and Tricks
  '6pf1f02CNjA', // How Does Making Payments Work?
  'u9EokVYAMqQ', // How Do I Check My Order Status?
  'TMDP2Hi8ptA', // How Do Shipping and Delivery Fees Work?
  'S6OEDmEvR6s', // How Does Title and Registration Work at Carvana?
  'evPNcIRmuGE' // How Does Carvana's 7-Day Money-Back Guarantee Work?
];

export const QuickAnswers = () => {
  const data = useHomeContext();
  const { isClient } = useBreakpoint();
  const videos = data?.allStrapiVideo?.edges;
  const tempSortedVideos = videoOrderDefinition
    .map((youtubeId) => videos?.find((x) => x?.node?.youtube_id === youtubeId))
    .filter(Boolean);
  const sortedVideos =
    tempSortedVideos && tempSortedVideos?.length > 0
      ? tempSortedVideos?.slice(0, 9)
      : videos?.slice(0, 9);
  const sortedVideoNodes = sortedVideos?.map((x) => x?.node);

  const [ref] = SendInViewEvent({
    isLoading: data?.isLoading,
    component_name: 'home_quick_answers',
    data: {
      videos,
      sortedVideos
    }
  });

  return (
    <Section ref={ref}>
      <HeaderTextBlock size="responsive">
        <HeaderTextBlockTitle>Quick Answers</HeaderTextBlockTitle>
      </HeaderTextBlock>

      <InnerSection>
        {isClient && sortedVideos && <VideoCarousel videos={sortedVideoNodes} />}
      </InnerSection>
    </Section>
  );
};
